// Formateadores humanos. Mantengo el mismo redondeo del prototipo para no desfasar los tiempos
// respecto a la referencia visual.

export const fmtMinutes = (seconds: number): string => {
  const m = Math.max(1, Math.round(seconds / 60));
  return `${m} min`;
};

export const fmtMeters = (meters: number): string => {
  if (meters < 1000) return `${Math.round(meters)} m`;
  return `${(meters / 1000).toFixed(1)} km`;
};

// «Hospital Vinalopo (293)»: nombre legible y número de poste para buscarlo en la marquesina.
export function stopLabel(s: { number: string; name: string }): string {
  if (!s.name) return `Parada ${s.number}`;
  const name = s.name.toLowerCase().replace(/(^|[\s.\-/(])(\p{L})/gu, (_m, p: string, c: string) => p + c.toUpperCase());
  return `${name} (${s.number})`;
}
